import isUnknownObject from './isUnknownObject';
import NodeTypes from './NodeTypes';
export default function isElement(node) {
  return isUnknownObject(node) && node.nodeType === NodeTypes.ELEMENT_NODE;
}
//# sourceMappingURL=isElement.js.map